/**
 * EL AVISO ANTES DE UNA MARCA REPETIDA (KIOSK-ALERTA-DUPLICADO-T1, Josse 25-sep).
 *
 * "Acabas de marcar X hace 1 minuto, ¿seguro?" y, cuando la API lo diga, "según tu horario toca Y". Dos capas:
 *   1. lo que ESTE aparato recuerda (las marcas que se hicieron aqui): cubre el doble toque, que es el caso comun;
 *   2. lo que diga la API en el DTO del kiosko cuando A lo publique (contrato propuesto en la bitacora):
 *      ultimaMarcaTipo, ultimaMarcaHaceSegundos, marcaSegunHorario. Si vienen, mandan; si no, la capa 1 sola.
 * Nunca bloquea: pregunta y deja confirmar (una marca legitima 2 minutos despues existe).
 *
 * Puro: sin DOM, sin red, sin reloj propio (se le pasa `ahora`). La memoria del aparato la guarda la vista.
 */

export const UMBRAL_MS = 3 * 60 * 1000;

export const NOMBRE_MARCA = Object.freeze({
  entrada: 'la entrada', inicio_almuerzo: 'la salida a almorzar', fin_almuerzo: 'el regreso del almuerzo', salida: 'la salida'
});

const leer = (o, ...k) => { for (const x of k) if (o && o[x] !== undefined && o[x] !== null) return o[x]; return null; };

/** "hace N minutos" en palabras cortas. */
export function haceCuanto(ms) {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return 'hace un momento';
  const m = Math.round(s / 60);
  return m === 1 ? 'hace 1 minuto' : `hace ${m} minutos`;
}

/**
 * ¿Hay que preguntar antes de marcar?
 * @param {{colaboradorId:string, accion:string, ahora:number, recientes?:Array<{colaboradorId,tipo,t}>, kiosk?:object}} x
 * @returns {{preguntar:boolean, lineas:string[]}}
 */
export function antesDeMarcar({ colaboradorId, accion, ahora, recientes = [], kiosk = null } = {}) {
  const lineas = [];
  // Capa 2 (API), si viene: la ultima marca con su edad segun el servidor.
  const tipoApi = leer(kiosk, 'ultimaMarcaTipo', 'UltimaMarcaTipo');
  const haceApi = leer(kiosk, 'ultimaMarcaHaceSegundos', 'UltimaMarcaHaceSegundos');
  let ultima = null;
  if (tipoApi && Number.isFinite(Number(haceApi))) ultima = { tipo: String(tipoApi), haceMs: Number(haceApi) * 1000 };
  // Capa 1 (este aparato): la marca mas reciente de ESTA persona aqui.
  const local = recientes.filter((r) => r && r.colaboradorId === colaboradorId && Number.isFinite(r.t)).sort((a, b) => b.t - a.t)[0];
  if (local && (!ultima || ahora - local.t < ultima.haceMs)) ultima = { tipo: local.tipo, haceMs: ahora - local.t };
  if (ultima && ultima.haceMs >= 0 && ultima.haceMs < UMBRAL_MS) {
    lineas.push(`Acabas de marcar ${NOMBRE_MARCA[ultima.tipo] || ultima.tipo} ${haceCuanto(ultima.haceMs)}.`);
  }
  // La que toca segun el horario (solo si la API la dice y no es la que va a registrar).
  const toca = leer(kiosk, 'marcaSegunHorario', 'MarcaSegunHorario');
  if (toca && toca !== accion) lineas.push(`Según tu horario toca ${NOMBRE_MARCA[toca] || toca}; vas a registrar ${NOMBRE_MARCA[accion] || accion}.`);
  return { preguntar: lineas.length > 0, lineas };
}

/** Recuerda una marca hecha en este aparato y olvida las viejas (solo sirven los ultimos minutos). */
export function recordarMarca(recientes, { colaboradorId, tipo, t }) {
  const vivos = (Array.isArray(recientes) ? recientes : []).filter((r) => r && Number.isFinite(r.t) && t - r.t < UMBRAL_MS);
  return [...vivos, { colaboradorId, tipo, t }].slice(-50);
}
